import PropTypes from 'prop-types';

const conditionShape = {
  targetColumn: PropTypes.string.isRequired,
  condition: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};

const propTypes = {
  filters: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape(conditionShape)))
    .isRequired,
};

class Filter {
  static conditionShape = conditionShape;
  static propTypes = propTypes;
}

export default Filter;
